import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import NavbarTop from '../components/navbar/NavbarTop';
import NavbarVertical from '../components/navbar/NavbarVertical';
import Footer from '../components/footer/Footer';
import { setDocumentTitle } from '../helpers/inbdeUtils';

import SearchPage from '../pages/SearchPage';
import PersonalTestletPage from '../pages/PersonalTestletPage';
import AdminRoutes from './AdminRoutes';
import ContentRoutes from './ContentRoutes';
import {
  adminAllContentPath,
  adminCoursePath,
  adminManageAccessPath,
  adminPath,
  adminRandomSetPath,
  adminReportPath,
  adminReviewContentPath,
  contentBasePath,
  personalContentPath,
  questionPath,
  searchPath,
  testletPath
} from '../routes';

const pageTitlesByPath = [
  { path: adminAllContentPath, name: 'All Content' },
  { path: adminReviewContentPath, name: 'Review Content' },
  { path: adminManageAccessPath, name: 'Manage Access' },
  { path: adminCoursePath, name: 'Courses' },
  { path: adminReportPath, name: 'Reports' },
  { path: adminRandomSetPath, name: 'Random Sets' },
  { path: searchPath, name: 'Search Content' },
  { path: personalContentPath, name: 'My Content' },
  { path: testletPath, name: 'Testlet' },
  { path: questionPath, name: 'Question' }
];

const DashboardLayout = ({ location, userAccess }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const page = pageTitlesByPath.find(entry => location.pathname.startsWith(entry.path));
    setDocumentTitle(page && page.name);
  }, [location.pathname]);

  return (
    <div className="container-fluid pr-xl-5 pl-xl-5">
      <a className="sr-only sr-only-focusable" href="#page-content">
        Skip to main content
      </a>
      <NavbarVertical userAccess={userAccess} />
      <div className="content">
        <NavbarTop />
        <main id="page-content">
          <Switch>
            <Route path={searchPath} exact render={props => <SearchPage {...props} />} />
            <Route path={contentBasePath} render={props => <ContentRoutes {...props} userAccess={userAccess} />} />
            <Route path={personalContentPath} component={PersonalTestletPage} />
            <Route path={adminPath} render={props => <AdminRoutes {...props} userAccess={userAccess} />} />
            <Redirect to="/errors/404" />
          </Switch>
        </main>
        <Footer />
      </div>
    </div>
  );
};

DashboardLayout.propTypes = { location: PropTypes.object.isRequired, userAccess: PropTypes.string };

export default DashboardLayout;
